import React, { FC } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import { ProductRecipeApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	recipes: ProductRecipeApi[];
	currentRecipeIndex: number;
	setCurrentRecipe: (index: number) => void;
	onRemove: (index: number) => void;
	onCreate: () => void;
}

const ProductRecipeButtons: FC<Props> = ({ recipes, currentRecipeIndex, setCurrentRecipe, onRemove, onCreate }) => {
	const { t } = useTranslation();

	const getStartDate = (recipe: ProductRecipeApi, index: number) => {
		if (index === 0) return "~";
		if (recipe.valid_from) return FormatDate(recipe.valid_from);

		const prevRecipe = recipes[index - 1];
		if (prevRecipe && prevRecipe?.valid_from) return FormatDate(prevRecipe.valid_from);
		return "~";
	};

	const getEndDate = (recipe: ProductRecipeApi, index: number) => {
		if (index === recipes?.length - 1) return "~";
		const nextRecipe = recipes[index + 1];
		if (nextRecipe && nextRecipe?.valid_from) return FormatDate(nextRecipe.valid_from);
		return "~";
	};

	const onRemoveRecipe = (e: React.MouseEvent<SVGSVGElement, MouseEvent>, index: number) => {
		e.stopPropagation();
		e.preventDefault();
		onRemove(index);
	};

	return (
		<div className="d-flex flex-wrap">
			{recipes?.map((recipe, index) => {
				return (
					<Button
						variant={`outline-${currentRecipeIndex === index ? "primary" : "dark"}`}
						key={`recipe-button-${index}`}
						className="me-2 mb-2"
						onClick={() => setCurrentRecipe(index)}
					>
						{getStartDate(recipe, index)} - {getEndDate(recipe, index)}
						{index !== 0 && (
							<RemoveSVG className="ms-2 remove-icon-red" onClick={(e) => onRemoveRecipe(e, index)} />
						)}
					</Button>
				);
			})}
			<Button onClick={onCreate} className="mb-2">
				{t("lib:common.action.add")}
			</Button>
		</div>
	);
};

export default ProductRecipeButtons;
